import React from 'react';
import { useSelector } from "react-redux";
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import MenuIcon from '@material-ui/icons/Menu';
import LocalCafeIcon from '@material-ui/icons/LocalCafe';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useHistory } from "react-router-dom";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";

import { auth } from "../../../firebase/firebase";
import classes from "./Sidebar.module.css";
import logo from "../../../img/crit_fail_logo.png";
import Campaigns from "./CampaignRooms/CampaignRooms";
import Characters from "./Characters/Characters";
import { selectChannelName } from "../../../store/reducers/appSlice";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',    
  },
  drawer: {
    background: '#202225',
    [theme.breakpoints.up('sm')]: {   
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    background: '#202225',
    [theme.breakpoints.up('sm')]: {
        
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
    background: '#202225',
    color: 'white',

  },

}));

function ResponsiveDrawer(props) {

  const classesMUI = useStyles();
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const channelName = useSelector(selectChannelName);
  const history = useHistory();

  const handleSignOut = () => {
    auth.signOut()
    history.push("/")
  };

  const drawer = (
    <div>
             <div className={classes.icon__wrap} onClick={() => {history.push("/");}}>
        <img src={logo} className={classes.icon} alt="icon" loading="lazy" />
      </div>
      <div className={classesMUI.toolbar} />
      
      <Divider />
      <List>
        <Campaigns />
        <Characters />
      </List>

      <div className={classes.sidebar__footer}>
        
          <IconButton
            className={classes.sidebar__button}
            onClick={handleSignOut}
          >
            <ExitToAppIcon fontSize="small" />
          </IconButton>
          <h4 className={classes.textHover} onClick={handleSignOut}>
            Logout
          </h4>
       
      </div>

    </div>
  );

  
  return (
    <div className={classesMUI.root}>
      <CssBaseline />
      <AppBar position="fixed" className={classesMUI.appBar}>
        
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={classesMUI.menuButton}
          >
            <MenuIcon color="primary" />
          </IconButton>
          <Typography variant="h6" noWrap color="primary">
            {channelName}
          </Typography>
          {/* Patreon link */}
          <Button color="secondary"
            aria-label="support via Patreon"
            onClick={(e) => {
              e.preventDefault();
              window.location.href="https://www.patreon.com/bePatron?u=57099158";
              }}
            className={classes.patreonLink}

            >
              <LocalCafeIcon color="secondary" />
              <h6>Become a Patron!</h6>
             
            </Button>
          
        </Toolbar>
      </AppBar>
      <nav className={classesMUI.drawer} aria-label="mailbox folders">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Hidden smUp implementation="css">
          <Drawer
            variant="temporary"
            anchor={theme.direction === 'rtl' ? 'right' : 'left'}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classesMUI.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden xsDown implementation="css">
          <Drawer
            classes={{
              paper: classesMUI.drawerPaper,
            }}
            variant="permanent"
            open
          >
            {drawer}
          </Drawer>
        </Hidden>
      </nav>
 
    </div>
  );
}

export default ResponsiveDrawer;